import React from 'react';
import styles from './style.css';

const FundListFundsInfo = ({ searchableFundsLength, filteredFundsLength }) => {
  return (
    <>
      <div className="matched-funds-info">
        <span>({filteredFundsLength})</span> of {searchableFundsLength} Funds
        Match
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default FundListFundsInfo;
